// Section for import npm components -----------------------------------------------------------------------------------
import React, { useState, useContext } from 'react';

// MUI components
import Box from '@mui/material/Box';
import Slide from '@mui/material/Slide';

// Section for import custom components --------------------------------------------------------------------------------
import MainLogo from '@components/common/MainLogo';
import GlobalNavigation from '@components/layout/Header/GlobalNavigation';
import MenuOpenIcon from '@components/layout/Header/MenuOpenIcon';
import MenuModal from '@components/layout/Header/MenuModal';
import MenuModalSP from '@components/layout/Header/SP/MenuModal';
import { AppConfigContext } from '@providers/AppConfigProvider';

export default function Header(): React.JSX.Element {
  const [isOpen, setIsOpen] = useState(false);

  const { isMobile } = useContext(AppConfigContext);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Box>
      <header className="w-full h-24 max-md:h-[72px] flex justify-between items-center m-0 py-4 pl-[60px] max-md:pl-5 max-sm:p-5">
        <MainLogo position="header" className="h-10 max-md:w-[132px] max-md:h-[30px]" />
        <Box className="mr-[108px] flex items-center max-md:hidden">
          <Slide direction="left" in>
            <Box className="xl:flex mr-4">
              <GlobalNavigation />
            </Box>
          </Slide>
        </Box>
        <MenuOpenIcon onClick={handleOpen} />
      </header>
      {isMobile ? (
        <MenuModalSP open={isOpen} handleClose={handleClose} />
      ) : (
        <MenuModal open={isOpen} handleClose={handleClose} />
      )}
    </Box>
  );
}
